var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div> <div id="setting_margin" class="setting_margin div100"> <div id="module_margin" class="div100"> <div id="qrcode" class="qrcode"> <div class="myqrcode"> <img id="qrcode_img" src=""> </div> <div id="text" class="mytext"> <span class="qrcode_text"></span> </div> <div id="qrcode_qrCodeContainer_2" style="text-align:center; display:none"> <div id="qrcode_container_2"></div> </div> <img id="qrcode_qrCodeLogo_2" crossorigin="anonymous" src="/images/Events4us.png" style="visibility:visible; height:0px"> <img id="qrcode_img_OrgImage_2" alt="" src="" style="display:none"> </div> </div> </div> </div>';
}
return __p;
};
